export default "__VITE_ASSET__Ch1M7QeH__"